import React, { Component } from 'react';
import { connect } from 'react-redux';
import {createSelector} from 'reselect';
//import { Link } from "react-router-dom";
import { Main } from '../../layout';
import { Container, Row, Col } from 'react-bootstrap';
import { DocumentTitle } from '../../../helpers';

class ContentPage extends Component {

    render() {
        const { pages, match } = this.props;
        const { slug } = match.params;
        const pagesArray = pages.data ? pages.data.filter(item => item.slug === slug) : [];
        const page = pagesArray && pagesArray[0];
        //console.log('pages', page);

        return (<Main>
            <DocumentTitle title={page && page.title}/>
            <div className={'content-page ' + slug}>
                <div className="w-100 py-5">
                    <Container>
                        <Row>
                            <Col>
                                <h2 className="text-left pb-3 text-info font-weight-bold page-title">{page && page.title}</h2>
                                <div dangerouslySetInnerHTML={{__html: page && page.content}}></div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </Main>);
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const pagesSelector = createSelector(
    state => state.pages,
    pages => pages
);

const mapStateToProps = createSelector(
    authenticationSelector,
    pagesSelector,
    (authentication, pages) => ({
        authentication, pages
    })
);

export default connect(mapStateToProps)(ContentPage);